<div class="ui-fluid ui-g-12 card">
  <!-- Report User, Company, Applications -->
<div class="ui-g-12">

  <div class="description ui-g-12">
    {{ 'report.userCompaniesAppReport' | translate }}
    <hr>
  </div>

  <div class="ui-g-12">
      <i class="fa fa-info-circle icon" style="float: right;" pTooltip="{{ 'report.info' | translate }}" tooltipPosition="left" (click)="openDialog('reportUserCompanyApp')"></i>
  </div>

  <!-- Filtri Report -->
  <div class="padd ui-g-12">

    <!-- Ruolo -->
    <div class="ui-g-6">
      <label>{{ 'common.role' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showRoleUserCompanyApp"></p-inputSwitch>
      <br><br>
      <p-dropdown [style]="{'width':'60%'}" [disabled]="!showRoleUserCompanyApp" [options]="roles" [(ngModel)]="roleSelectedUserCompanyApp"></p-dropdown>
    </div>

    <!-- Utente -->
    <div class="ui-g-6">
      <label>{{ 'common.username' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showUserUserCompanyApp"></p-inputSwitch>
      <br><br>
      <p-dropdown [style]="{'width':'60%'}" [disabled]="!showUserUserCompanyApp" [options]="users" [(ngModel)]="userSelectedUserCompanyApp" [filter]="true"></p-dropdown>
    </div>

    <!-- Company -->
    <div class="ui-g-6 padd-top">
      <label>{{ 'common.company' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showCompanyUserCompanyApp"></p-inputSwitch>
      <br><br>
      <p-dropdown [style]="{'width':'60%'}" [disabled]="!showCompanyUserCompanyApp" [options]="companies" [(ngModel)]="companySelectedUserCompanyApp"></p-dropdown>
    </div>

    <!-- Application -->
    <div class="ui-g-6 padd-top">
      <label>{{ 'common.application' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showApplication"></p-inputSwitch>
      <br><br>
      <p-dropdown [style]="{'width':'80%'}" [disabled]="!showApplication" [options]="applications" [(ngModel)]="applicationSelectedUserCompanyApp"></p-dropdown>
    </div>

  </div>

  <div class="ui-g-12 text-center padd-top">
    <p-button
        styleClass="ui-button-info"
        label="{{ 'report.viewReport' | translate }}"
        (onClick)="reportUserCompanyApplication()"
        >
      </p-button>
  </div>
</div>
</div>

<!-- Report -->
<div *ngIf="showReport" class="ui-g-12">
  <app-view-report
  [showUserCompanyApp]="showReportUserCompanyApp"
  [data]="report">
  </app-view-report>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-user-company-app/report-user-company-app.component.html